export default "__VITE_ASSET__jtzRH0ss__"